import { AssetCatalog, ConfigEditor } from "src/Modules";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Arbitrage } from "src/Modules/Arbitrage";
import { PredictionsModule } from "src/Modules/Predictions";
import { Login } from "src/Modules/Login";
import { Layout } from "src/Common";
import { AUTH_DISABLED } from "./Providers";
import { useAuth } from "src/Common/context/AuthContext";
import { NotificationSoundManager } from "src/Modules/Predictions/components/notifications/NotificationSoundManager";

function getDefaultRoute(): string {
  const storedMode = localStorage.getItem("app_mode");
  if (storedMode === "predictions") return "/predictions/opportunities";
  return "/arbitrage";
}

const AuthenticatedApp = () => (
  <BrowserRouter>
    {/* Global audio cue manager — renders nothing visible, plays
        notification sounds (alarm / fills / TNA) on every authenticated
        page. Cross-tab leader-elected via Web Locks so only one tab
        rings even with multiple browser windows open. The manual chime
        is still scoped to /predictions/notifications. */}
    <NotificationSoundManager />
    <Layout>
      <Routes>
        <Route path="arbitrage/*" element={<Arbitrage />} />
        <Route path="predictions/*" element={<PredictionsModule />} />
        <Route path="config-editor/*" element={<ConfigEditor />} />
        <Route path="assets" element={<AssetCatalog />} />
        {/* Redirects from old paths */}
        <Route
          path="prediction-mapper"
          element={<Navigate replace to="/predictions/mapper" />}
        />
        <Route
          path="arbitrage/predictions"
          element={<Navigate replace to="/predictions/opportunities" />}
        />
        <Route
          path="arbitrage/predictions/*"
          element={<Navigate replace to="/predictions/opportunities" />}
        />
        <Route
          path="arbitrage/predictions-status"
          element={<Navigate replace to="/predictions/status" />}
        />
        <Route path="/" element={<Navigate replace to={getDefaultRoute()} />} />
      </Routes>
    </Layout>
  </BrowserRouter>
);

export const AppRouter = () => {
  const { isAuthenticated } = useAuth();

  if (AUTH_DISABLED || isAuthenticated) {
    return <AuthenticatedApp />;
  }

  return <Login />;
};
